<div class="registration-popup">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
      <h2 class="text-center" id="FPWModalLabel">Sign in with your code</h2>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
        <span class="hint-text text-center mg-btm-32">Didn't get a code? 
          <span (click)="resendCode()" role="button" class="resend-link">Resend the email.</span>
        </span>
    </div>
  </div>

  <!-- <app-alert [alertService]="alertService"></app-alert> -->

  <form #signInCodeFormDlg name="form" (ngSubmit)="onSubmit()" [formGroup]="signInCodeForm" novalidate>
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left">
        <div class="form-group" [ngClass]="{ 'ng-invalid': !signInCodeForm.controls.code.valid }">
          <label for="code">Code</label>
          <input #codeFld type="text" class="form-control" id="code" name="code" autocomplete="one-time-code"
          formControlName="code" mask='000-000' [showMaskTyped]="false" [validation]="true"
          (input)="onCodeChange()"/>
          <app-validation-message [control]="signInCodeForm.controls.code" class="form-error"
          [updateOn]="updateTrigger.Dirty" ignoreDirtyValidationPattern="^\d{1,6}$"></app-validation-message>
          <div class="form-error valid-error" *ngIf="errorMessage">{{errorMessage}}</div>
        </div>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mg-top-24">
        <div class="form-group">
          <button type="submit"
            class="btn wb-btn-default center-block"
            [disabled]="(loading || disableSignInButton || !signInCodeForm.valid)">
            Sign In
          </button>
        </div>
      </div>
      <div class="text-center mg-top-24 mg-btm-9">
          <span role="button" (click)="childClosed()" class="btn wb-btn-outline">Cancel</span>
      </div>
    </div>
  </form>
</div>
